import { useEffect, useState } from "react";
import { baseAxios } from "../apis";

// Proves the session cookie carried over from the main site's login.
// No local login form exists here on purpose — auth always comes from
// the main site via the shared cookie domain.
export function useCurrentUser() {
  const [user, setUser] = useState(null);
  const [status, setStatus] = useState("loading"); // loading | authed | anonymous

  useEffect(() => {
    baseAxios
      .get("/api/whoami/")
      .then((res) => {
        setUser(res.data);
        setStatus("authed");
      })
      .catch(() => setStatus("anonymous"));
  }, []);

  return { user, status };
}
